export default class Diagnosis {
  readonly id?: number;
  readonly updated_at?: string;
  created_at?: string;
  procedure_code?: string;
  description?: string;
}
